module.exports = __webpack_public_path__ + "img/20210213_185948.dfa3f5c5.jpg";